import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Virement from './virement';
import VirementCreateModal from './virement-validation-modal';
import virementDashboard from './virementDasboard';
import VirementDetail from './virement-details';
const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId`} component={Virement} />
      <ErrorBoundaryRoute path={`${match.url}/demande/:id/details`} component={VirementDetail} />
      <ErrorBoundaryRoute path={match.url} component={virementDashboard} />
    </Switch>

    <ErrorBoundaryRoute path={`${match.url}/demande/:id/validation`} component={VirementCreateModal} />
  </>
);
export default Routes;
